import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { MarshallExplanationDrawer } from './marshall-explanation-drawer.component'

export interface MarshallExplanationDrawerContextProps {
  showMarshallExplanationDrawer: boolean
  setShowMarshallExplanationDrawer: Dispatch<SetStateAction<boolean>>
}

export const MarshallExplanationDrawerContext =
  createContext<MarshallExplanationDrawerContextProps>({
    showMarshallExplanationDrawer: false,
    setShowMarshallExplanationDrawer: () => null,
  })

export const useMarshallExplanationDrawer = () =>
  useContext(MarshallExplanationDrawerContext)

interface MarshallExplanationDrawerProviderProps {
  children: React.ReactNode
}

const MarshallExplanationDrawerProvider: React.FC<
  MarshallExplanationDrawerProviderProps
> = ({ children }) => {
  const [showMarshallExplanationDrawer, setShowMarshallExplanationDrawer] =
    useState<boolean>(false)
  return (
    <MarshallExplanationDrawerContext.Provider
      value={{
        showMarshallExplanationDrawer,
        setShowMarshallExplanationDrawer,
      }}
    >
      <MarshallExplanationDrawer />
      {children}
    </MarshallExplanationDrawerContext.Provider>
  )
}

export { MarshallExplanationDrawerProvider }
